import state from "./modulePlotEditState.js";
import mutations from "./modulePlotEditMutations.js";
import actions from "./modulePlotEditActions.js";
import getters from "./modulePlotEditGetters.js";

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
